/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
// DEPENDENCIES
import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import moment from 'moment';
// COMPONENTS
import SVG from "react-inlinesvg";
import { HubConnectionBuilder } from '@microsoft/signalr';
import { Badge } from "react-bootstrap";
// ICONS
import { GoPrimitiveDot } from 'react-icons/go';
import { IoClose } from 'react-icons/io5';
// CUSTOM COMPONENTS
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../../_helpers";
import constants from "../../../../../constants/constants";
import * as notificationService from "../../../../../services/notification/notificationService";

const QuickPanel = (props) => {
  const { notifications, setNotifications, removeNotification } = props;
  const [archivedNotifications, setArchivedNotifications] = useState([]);
  const [notificationType, setNotificationType] = useState("Active");
  let history = useHistory();


  const toggleNotificationType = () => {
    if (notificationType === 'Active') {
      fetchArchivedNotifications().finally(() => {
        setNotificationType('Archived')
      })
    } else {
      setNotificationType('Active');
    }
  }

  const fetchArchivedNotifications = () => {
    return notificationService.getNotification(true).then(res => {
      setArchivedNotifications(res);
    })
  }

  const changeNotificationStatusAndRoute = (notificationId, path, hasOpened) => {
    if (hasOpened) {
      if (path) {
        history.push(path);
      }
      return;
    }

    notificationService.setNotificationAsRead(notificationId).then(res => {
      let copiedNotifications = [...notifications];
      copiedNotifications.find(x => x.id == notificationId).hasOpened = true;

      setNotifications(copiedNotifications);
      //route to where
      if (path) {
        history.push(path);
      }
    }).catch(ex => console.log(ex));
  }

  return (
    <div id="kt_quick_panel" className="offcanvas offcanvas-left pt-5 pb-10" style={{ "overflow-y": "scroll" }}>
      <div className="mb-5 container">
        <h5 className="font-weight-bold mb-5">Notifications</h5>
        <Badge style={{ cursor: 'pointer', background: '#07522d', color: 'white' }} onClick={toggleNotificationType} bg="primary">
          Show {notificationType === "Active" ? "Archived" : "Active"} Notifications
        </Badge>
        <hr />
        {
          notifications &&
            (notifications.length > 0 || archivedNotifications.length > 0) ? (notificationType === "Active" ? notifications : archivedNotifications).map(x => (
              <div key={x.id} className={"d-flex align-items-center bg-light-" + x.type.toLowerCase() + " rounded p-5 mb-5"} style={{ position: "relative" }}>

                <div className="d-flex flex-column flex-grow-1 mr-2">
                  <a
                    href="#"
                    onClick={() => changeNotificationStatusAndRoute(x.id, x.link, x.hasOpened)}
                    className="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1"
                  >
                    {x.message}
                  </a>
                  <span className="text-muted font-size-sm">
                    {moment(x.dateTime).format("ddd, MMM DD hh:mm a")} {/* Due in 2 Days */}
                  </span>
                </div>

                {
                  !x.hasOpened && <span className="font-weight-bolder text-info py-1 font-size-lg">
                    <GoPrimitiveDot />
                  </span>
                }

                <a onClick={() => removeNotification(x.id)} style={{ position: "absolute", top: 0, right: 0, marginRight: 14, marginTop: 10 }}>
                  <IoClose size={18} className="dark-grey--clr" />
                </a>

              </div>
            )) : <div className={"d-flex align-items-center bg-light-secondary rounded p-5 mb-5"}>
            <div className="d-flex flex-column flex-grow-1 mr-2">
              <a
                href="#"
                className="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1"
              >
                No new notifications
              </a>
            </div>
          </div>
        }
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  auth: state.auth
})

export default connect(mapStateToProps, null)(QuickPanel);